import { useAuth } from "@/context/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, AlertTriangle, HelpCircle } from "lucide-react";

const NAV = [
  { label: "Acasă", route: "/", testId: "nav-home" },
  { label: "Leasing", route: "/leasing", testId: "nav-leasing" },
  { label: "Cheltuieli în avans", route: "/cheltuieli-in-avans", testId: "nav-prepaid-expenses" },
  { label: "Carburanți", route: "/carburanti", testId: "nav-fuel" },
];

export default function Layout({ children }) {
  const { user, logout, pilot } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const nav = [...NAV];
  if (user?.role === "admin") nav.push({ label: "Administrare", route: "/admin", testId: "nav-admin" });

  const isActive = (route) => (route === "/" ? location.pathname === "/" : location.pathname.startsWith(route));

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {pilot && (
        <div
          data-testid="pilot-banner"
          className="sticky top-0 z-50 w-full bg-amber-400 text-slate-950 px-4 py-1.5 text-center text-xs sm:text-sm font-bold tracking-wide uppercase shadow-sm flex items-center justify-center gap-2 border-b border-amber-500"
        >
          <AlertTriangle className="h-4 w-4" />
          PILOT — date de test, cu denumiri fictive
        </div>
      )}

      <header className="sticky z-40 bg-slate-900 text-slate-100 border-b border-slate-800" style={{ top: pilot ? "30px" : "0" }}>
        <div className="px-4 sm:px-6 lg:px-8 flex items-center justify-between h-14">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-2">
              <div className="h-7 w-7 rounded bg-[#FFC800] flex items-center justify-center font-display font-extrabold text-slate-950 text-sm">
                J
              </div>
              <span className="font-display font-bold tracking-tight text-base">Portal Jungheinrich</span>
            </div>
            <nav className="hidden md:flex items-center gap-1">
              {nav.map((n) => (
                <Link
                  key={n.route}
                  to={n.route}
                  data-testid={n.testId}
                  className={`px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                    isActive(n.route)
                      ? "bg-[#FFC800] text-slate-950"
                      : "text-slate-300 hover:bg-slate-800 hover:text-white"
                  }`}
                >
                  {n.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/manual/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-help"
              className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium text-slate-300 hover:bg-slate-800 hover:text-white transition-colors"
            >
              <HelpCircle className="h-4 w-4" /> Ajutor
            </a>
            <span className="hidden sm:block text-xs text-slate-400" data-testid="current-user">
              {user?.name} · {user?.role === "admin" ? "Admin" : "Utilizator"}
            </span>
            <Button
              data-testid="logout-btn"
              variant="ghost"
              size="sm"
              className="text-slate-300 hover:text-white hover:bg-slate-800"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
            >
              <LogOut className="h-4 w-4 mr-1" /> Ieșire
            </Button>
          </div>
        </div>
        <nav className="md:hidden flex items-center gap-1 px-4 pb-2 overflow-x-auto">
          {nav.map((n) => (
            <Link
              key={n.route}
              to={n.route}
              className={`px-3 py-1.5 rounded text-xs font-medium whitespace-nowrap ${
                isActive(n.route) ? "bg-[#FFC800] text-slate-950" : "text-slate-300 hover:bg-slate-800"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
      </header>

      <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6 max-w-[1800px] w-full mx-auto">{children}</main>
    </div>
  );
}
